import React from "react";

const StatBadge = ({ value, label }: { value: number; label: string }) => {
  return (
    <div className="text-center px-3">
      <div className="fs-4 fw-bold text-primary">{value ?? 0}</div>
      <div className="text-muted small">{label}</div>
    </div>
  );
};

export default StatBadge;
